<template>
    <div class="main">
        <h2>订单查询</h2>
        <v-form style="width: 100%; margin-top: 40px;"
                label-width="6em"
                :model="form"
        >
            <v-form-item label="订单号">
                <input class="form-control" type="text" v-model="form.id">
            </v-form-item>
            <v-form-item label="联系人手机">
                <input class="form-control" type="text" v-model="form.customerPhone">
            </v-form-item>
        </v-form>
        <v-form style="width: 100%; margin-top: 30px;"
                label-width="6em"
                :model="form"
        >
            <v-form-item label="产品编号">
                <input class="form-control" type="text" v-model="form.productNo">
            </v-form-item>
            <v-form-item label="产品关键字">
                <input class="form-control" type="text" v-model="form.productName">
            </v-form-item>
            <v-button type="primary" @click="searchOrder">搜索</v-button>
        </v-form>
        <h2>查询结果<v-button type="primary" @click="exportExcel">导出订单</v-button></h2>
        <v-table style="width: 100%; background-color: #FFF; margin-top: 20px;"
                 :data="tableData"
                 :column="tableColumn"
                 v-loading="isLoading"
        >
            <template slot="productInfo" scope="props">
                <div>产品名称：{{ props.data.productName }}</div>
                <div>产品编号：{{ props.data.productNo }}</div>
                <div>货号：{{ props.data.goodsNo }}</div>
            </template>
            <template slot="customerInfo" scope="props">
                <div>{{ props.data.customerName }}</div>
                <div>{{ props.data.customerPhone }}</div>
                <div>{{ props.data.customerAddress }}</div>
            </template>
            <template slot="action" scope="props">
                <div>{{ props.data.deliveryNo | formatOrderStatus }}</div>
                <div class="refuse-btn" @click="showRefuseRefundDialog(props.data)">拒绝退款</div>
                <div class="allow-btn" @click="showAllowRefundDialog(props.data)">允许退款</div>
            </template>
        </v-table>
        <v-pagination
            :current='currentPage'
            :total='Math.ceil(totalCount / 20)'
            :size="'md'"
            :first="false"
            :last="false"
            v-on:current-change="currentChangeFunc($event)"
            style="text-align: right;"
        ></v-pagination>
        <v-dialog v-model="refuseRefundDialog" title="拒绝退款" :modalAppendToBody="false">
            <ul>
                <li>
                    <label>拒绝原因：</label>
                    <v-select v-model="refuse_reason_val" placeholder="请选择">
                        <v-option v-for="(item, key) in REFUSE_REASON" :label="item" :value="item" :key="key"></v-option>
                    </v-select>
                </li>
            </ul>
            <div slot="footer" class="dialog-footer">
                <button class="btn btn-default" @click="cancel">取消</button>
                <button class="btn btn-warning" @click="refuseRefund">拒绝退款</button>
            </div>
        </v-dialog>
        <v-dialog v-model="allowRefundDialog" title="允许退款" :modalAppendToBody="false">
            <ul>
                <li>
                    <label>退款备注：</label>
                    <input type="text" class="form-control" v-model="refund_reason_val">
                </li>
            </ul>
            <div slot="footer" class="dialog-footer">
                <button class="btn btn-default" @click="cancel">取消</button>
                <button class="btn btn-warning" @click="allowRefund">允许退款</button>
            </div>
        </v-dialog>
    </div>
</template>

<style lang="scss" scoped="scoped">
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 15px;
        > h2 {
            font-size: 24px;
            &:nth-of-type(n+2) {
                margin-top: 60px;
            }
            > .btn {
                float: right;
            }
        }
        .form-horizontal {
            display: flex;
            .v-form-item {
                width: 20%;
                margin-bottom: 0;
                &:nth-child(n+2) {
                    margin-left: 5%;
                }
                .form-control {
                    width: 100%;
                    display: inline-block;
                }
            }
            .btn-primary {
                margin-left: 30px;
                width: 120px;
            }
        }
        .xigua-modal-dialog {
            ul {
                list-style: none;
                padding: 0;
                li {
                    height: 40px;
                    line-height: 40px;
                    &:nth-child(n+2) {
                        margin-top: 5px;
                    }
                    label {
                        vertical-align: top;
                        height: 100%;
                        margin: 0;
                        width: 100px;
                        font-weight: bold;
                        text-align: right;
                    }
                    p {
                        display: inline-block;
                        vertical-align: top;
                        height: 100%;
                        margin: 0 0 0 10px;
                    }
                    .el-select {
                        display: inline-block;
                        width: 250px;
                    }
                    .form-control {
                        display: inline-block;
                        width: 250px;
                    }
                }
            }
        }
        .refuse-btn {
            width: 50%;
            background-color: #DE290C;
            color: #FFF;
            padding: 5px 0;
            border-radius: 3px;
            display: inline-block;
            margin-top:5px;
        }
        .allow-btn {
            width: 50%;
            background-color: #3dc6b6;
            color: #FFF;
            padding: 5px 0;
            border-radius: 3px;
            display: inline-block;
            margin-top:5px;
        }
    }
</style>

<script>
    import Api from 'api/wenchuang'
    import Moment from 'moment'
    import { REFUSE_REASON } from '../constant.js'

    export default {
        data () {
            return {
                form: {
                    id: '',
                    customerPhone: '',
                    productNo: '',
                    productName: ''
                },
                orderState: 5, // 申请退款订单
                currentPage: 1,
                totalCount: 0,
                tableData: [],
                tableColumn: [
                    {
                        key: 'id',
                        name: '订单号'
                    },
                    {
                        key: 'productInfo',
                        name: '产品名称',
                        type: 'slot',
                        slot: 'productInfo'
                    },
                    {
                        key: 'totalPrice',
                        name: '总价'
                    },
                    {
                        key: 'refundGoodsInfo',
                        name: '商家信息'
                    },
                    {
                        key: 'orderCreateTime',
                        name: '下单时间'
                    },
                    {
                        key: 'customerInfo',
                        name: '联系人信息',
                        type: 'slot',
                        slot: 'customerInfo'
                    },
                    {
                        key: 'extInfo',
                        name: '备注'
                    },
                    {
                        key: 'action',
                        name: '操作',
                        type: 'slot',
                        slot: 'action'
                    }
                ],
                nowOrderId: '', // 当前弹层的订单id
                refuseRefundDialog: false, // 拒绝退款弹层
                REFUSE_REASON: REFUSE_REASON, // 拒绝原因
                refuse_reason_val: '', // 拒绝原因值
                allowRefundDialog: false, // 允许退款弹层
                refund_reason_val: '', // 退款原因
                isLoading: false
            }
        },
        filters: {
            formatOrderStatus (deliveryNo) {
                if (!deliveryNo || deliveryNo === '') {
                    return '未发货';
                } else {
                    return '已发货';
                }
            }
        },
        methods: {

            // 获取订单数据
            getTableData () {
                this.isLoading = true;
                Api.getOrderListData(this.orderState, this.form, this.currentPage)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            let data = res.data;
                            let tableData = [];
                            data.forEach((item) => {
                                tableData.push({
                                    id: item.id,
                                    productInfo: {
                                        productName: item.productName,
                                        productNo: item.productNo,
                                        goodsNo: item.goodsNo
                                    },
                                    totalPrice: item.totalPrice,
                                    refundGoodsInfo: item.refundGoodsInfo,
                                    orderCreateTime: Moment(item.orderCreateTime).format('YYYY-MM-DD HH:mm:ss'),
                                    customerInfo: {
                                        customerName: item.customerName,
                                        customerPhone: item.customerPhone,
                                        customerAddress: item.customerAddress
                                    },
                                    extInfo: item.extInfo,
                                    action: {
                                        id: item.id,
                                        deliveryNo: item.deliveryNo
                                    }
                                })
                            })
                            this.tableData = tableData;
                            this.totalCount = res.paging.count;
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            // 显示拒绝退款弹层
            showRefuseRefundDialog (data) {
                this.nowOrderId = data.id;
                this.refuseRefundDialog = true;
            },

            // 取消弹层
            cancel () {
                this.refuseRefundDialog = false;
                this.allowRefundDialog = false;
            },

            // 确定拒绝退款
            refuseRefund () {
                if (this.refuse_reason_val === '') {
                    this.$message({
                        message: '请选择拒绝原因',
                        type: 'error'
                    });
                    return;
                }
                Api.handleRefund(this.nowOrderId, 2, this.refuse_reason_val)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.refuseRefundDialog = false;
                            this.$alert({
                                title: '提示',
                                message: '拒绝退款成功',
                                showCancelButton: false,
                                closeOnClickModal: false
                            }).then(() => {
                                window.location.reload();
                            })
                        } else {
                            this.$message({
                                message: '提交失败',
                                type: 'error'
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$message({
                            message: '操作失败' + (err.data ? '，' + err.data : ''),
                            type: 'error'
                        });
                    })
            },

            // 显示允许退款弹层
            showAllowRefundDialog (data) {
                this.nowOrderId = data.id;
                this.allowRefundDialog = true;
            },

            // 确定允许退款
            allowRefund () {
                if (this.refund_reason_val.trim().length > 30 || this.refund_reason_val.trim().length === 0) {
                    this.$message({
                        message: '请填写不超过30字的退款原因',
                        type: 'error'
                    });
                    return;
                }
                Api.handleRefund(this.nowOrderId, 1, this.refund_reason_val)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.allowRefundDialog = false;
                            this.$alert({
                                title: '提示',
                                message: '允许退款成功',
                                showCancelButton: false,
                                closeOnClickModal: false
                            }).then(() => {
                                window.location.reload();
                            })
                        } else {
                            this.$message({
                                message: '提交失败',
                                type: 'error'
                            });
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$message({
                            message: '操作失败' + (err.data ? '，' + err.data : ''),
                            type: 'error'
                        });
                    })
            },

            // 搜索订单
            searchOrder () {
                this.getTableData();
            },

            // 导出订单
            exportExcel () {
                let params = {
                    orderState: this.orderState,
                    id: this.form.id,
                    customerPhone: this.form.customerPhone,
                    productNo: this.form.productNo,
                    productName: this.form.productName,
                    orderRefundStatus: -1
                }
                Api.downloadOrder(params);
            },

            // 切换页码
            currentChangeFunc (ev) {
                this.currentPage = ev.current;
                this.getTableData();
            }
        },
        created () {
            this.getTableData();
        }
    }
</script>


// WEBPACK FOOTER //
// Main.vue?ad03f3d4